import React from 'react';
import '../style/Comsumer.scss';
const Consumer = () => {
    return (
      <div className="consumer-container">
        <h1 className="title">Get Started with Our Consumer Component!</h1>
        <p className="description">This component is currently under development, but you can start building your amazing application right away!</p>
        <p className="hint">Feel free to add more content, such as forms, buttons, or any other elements you need to make your application shine.</p>
      </div>
    );
  };

export default Consumer;
